import { Box, Divider, Grid, TextField, Typography } from "@mui/material";
import styled from "styled-components";
import { theme } from "styles/mui-config";
import CardContent from "@mui/material/CardContent";

export const StyledCardContent = styled(CardContent)`
  color: ${theme.palette.primary.dark};
  // border-right: 4px solid ${theme.palette.primary.dark};
  padding: 10px !important;
  // margin-top: 20px;
  position: relative;
  & p {
    text-align: center;
    padding-top: 10px;
  }
  &::before {
    content: "";
    position: absolute;
    right: 50%;
    left: 50%;
    top: 0px;
    width: 100px;
    border: 3px solid ${theme.palette.primary.dark};
    border-radius: 1px;
    border-bottom-right-radius: 6px;
    border-bottom-left-radius: 6px;
    pointer-events: none;
    transform: translate(50%);
  }
`;

export const StyledContainerBox = styled.div`
  width: 100% !important;
  position: relative !important;
  & .MuiOutlinedInput-root label,
  & .MuiOutlinedInput-root div,
  & .MuiOutlinedInput-root input,
  & .MuiOutlinedInput-root fieldset {
    opacity: 0 !important;
  }
`;
export const StyledUploadBox = styled.div`
  width: 100% !important;
  height: 100% !important;
  color: ${(props) =>
    props.file ? (props.error ? "#d32f2f" : "black") : "rgba(0, 0, 0, 0.6)"};
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: absolute;
  top: 0px;
  left: 0px;
  border: 1px solid
    ${(props) => (props.error ? "#d32f2f" : "rgba(0, 0, 0, 0.23)")};
  border-radius: 5px;
  padding: 5.1px 14px;
  & svg {
    color: ${theme.palette.primary.main};
    font-size: 24px;
    margin: 0px !important;
    padding: 0px !important;
  }
`;
export const StyledChoiceFileText = styled.span`
  max-width: 100% !important;
  color: #333 !important;
  font-size: 17px !important;
  margin: 0px !important;
  padding: 0px !important;
`;